import DOMPurify from 'isomorphic-dompurify';
import mammoth from 'mammoth';

function copyBuffer(bytes: ArrayBuffer): ArrayBuffer {
  const copy = new ArrayBuffer(bytes.byteLength);
  new Uint8Array(copy).set(new Uint8Array(bytes));
  return copy;
}

function mammothInput(bytes: ArrayBuffer): { arrayBuffer: ArrayBuffer; buffer?: Uint8Array } {
  const arrayBuffer = copyBuffer(bytes);
  // Vite uses mammoth's browser build (`arrayBuffer`). Vitest uses the Node
  // build, which only reads `buffer`. Pass both so either unpacker runs.
  const nodeBuffer = (globalThis as { Buffer?: { from(data: ArrayBuffer): Uint8Array } }).Buffer;
  if (!nodeBuffer) return { arrayBuffer };
  return { arrayBuffer, buffer: nodeBuffer.from(arrayBuffer) };
}

/**
 * Client-side .docx → HTML. This is the preview, not the pdf-lib rendition:
 * that path blocked on storage and could leave a blank PDF page.
 * Legacy .doc is not OOXML and throws, so the viewer shows the fallback.
 */
export async function docxPreviewHtml(bytes: ArrayBuffer): Promise<string> {
  const result = await mammoth.convertToHtml(mammothInput(bytes));
  const clean = DOMPurify.sanitize(result.value, { USE_PROFILES: { html: true } }).trim();
  if (!clean) throw new Error('preview_docx');
  return clean;
}
